const MODE = process.env
const apilist = 
{
    'dev':'192.168.131.196:3001',
    'qat':'192.168.131.198:3001',
    'uat':'',
    'prd':''
}
const apiurl = apilist[MODE]
module.exports = apiurl